import "./utils/fetch_monitor.js";
import { showToastMessage } from './utils/toast_message.js';
import { flipCardImage } from "./utils/sketches/card_image_flip.js";
import { loadMoreSketches } from "./utils/sketches/more_fetcher.js";
import { handleFetchError } from "./utils/fetch_utils.js";
import { applyUrlFilters, updateUrlFilters } from "./utils/sketches/url_filters.js";
import { initSignatureIdentifyModal } from "./utils/sketches/signature_identify.js";

window.showToastMessage = showToastMessage;

let sketchGallery;
let loadSpinner;
let characterList;
let artistFilter;
let characterFilter;
let filterDiv;
let resetFiltersButton;

document.addEventListener('DOMContentLoaded', function() {
    initializeSketchesPage();
})

function initializeSketchesPage(){
    window.configAlertTimeout = document.getElementById('window-alert-timeout').dataset.alertTimeout;
    sketchGallery = document.getElementById('sketch-results');
    loadSpinner = document.getElementById('load-sketches-spinner');
    artistFilter = document.getElementById('artistFilter');
    characterFilter = document.getElementById('characterFilter');
    filterDiv = document.getElementById('filtersDiv');
    resetFiltersButton = document.getElementById('reset-filters-btn');

    resetFiltersButton.addEventListener('click', () => {
       const alreadyClear = characterFilter.value === "" && artistFilter.value === "";
       if (!alreadyClear){
           characterFilter.value = "";
           artistFilter.value = "";
           updateUrlFilters(undefined, undefined);
           loadSketchGallery(undefined, undefined);
       }
    });

    filterDiv.addEventListener('change', (event) => {
        if (["characterFilter", "artistFilter"].includes(event.target.id)){
            const artist = artistFilter.value === "" ? undefined : artistFilter.value;
            const character = characterFilter.value === "" ? undefined : characterFilter.value;
            updateUrlFilters(artist, character);
            loadSketchGallery(artist, character);
        }
    });

    characterList = JSON.parse(
        document.getElementById("character-data").textContent
    );

    sketchGallery.addEventListener('click', (event) => {
        if (event.target.closest('.sketch-image-container')){
            flipCardImage(event);
        }
    });
    initSignatureIdentifyModal();
    const { artist, character } = applyUrlFilters(artistFilter, characterFilter);
    loadSketchGallery(artist, character);
}

function loadSketchGallery(artist = null, character = null){
    sketchGallery.innerHTML = ``;
    let urlString = '/sketch_cards?limit=20&p=1';
    if(artist){
        urlString += `&artist=${encodeURIComponent(artist)}`;
    }
    if(character){
        urlString += `&character=${encodeURIComponent(character)}`;
    }

    loadSpinner.classList.remove('d-none');
    fetch(`${urlString}`)
        .then(response => {
            if(!response.ok){
                throw new Error('Error getting sketches');
            }
            return response.text();
        })
        .then(html => {
            sketchGallery.innerHTML = html;
        })
        .catch(handleFetchError)
        .finally(() => {
            loadSpinner.classList.add('d-none');

            const loader = document.getElementById("sketch-loader");

            if (loader) {

                const observer = new IntersectionObserver(
                    entries => {

                        if (entries[0].isIntersecting) {
                            loadMoreSketches(undefined, true);
                        }
                    },
                    {
                        rootMargin: "300px"
                    }
                );
                observer.observe(loader);
            }
        });
}